<template>
  <ul @click="sideBarClick()">
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in myItems"
      :key="item.header || item.title"
      :item="$t(item)"
    />

    <li
      id="updateSideBar"
      @click="checkStatus()"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import { mapGetters } from 'vuex'
import store from '@/store'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'
import {tooltip} from "leaflet";
import seller from "@/router/seller";

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      checkMyRole: false,
      showNav: false,
      required: true,
    },
  },
  data() {
    return {
      company: null,
      myItems: [],
      load: false,
      referralSetting: 'none',
    }
  },
  computed: {
    ...mapGetters(['showInvoiceGetters', 'showDocsGetters']),
    invoice() {
      return this.$store.state.verticalMenu.showInvoice
    },
    docs() {
      return this.$store.showDocs
    },
    loader() {
      return this.load
    },
  },
  mounted() {
    this.$http.get('/referral-program/referral-setting/get')
        .then(response => {
          this.referralSetting = response.data.value;
          this.checkStatus();
        })
        .catch(error => {
          console.error('Failed to fetch referral setting:', error);
          this.checkStatus();
        });
  },
  methods: {
    referralIsActiveForRole(role) {
      return (
          this.referralSetting === 'all' ||
          (this.referralSetting === 'buyers' && role === 'buyer') ||
          (this.referralSetting === 'sellers' && role === 'seller')
      )
    },
    sideBarClick() {
      this.$store.commit('app/ON_SIDEBAR_CLICK', true)
      this.$store.commit('auth/SHOW_ALERT', false)
      this.$root.$emit('bv::hide::tooltip')
    },
    async checkStatus() {
      this.myItems = []
      this.myItems.push({
        title: 'dashboard',
        route: 'home',
        icon: 'HomeIcon',
      })
      const { user } = this.$store.state.auth
      await this.$http.post('/company/tasks').then(res => {
        this.company = this.$store.state.app
        && this.$store.state.app.company
        && this.$store.state.app.company.value
            ? this.$store.state.app.company.value
            : null

        if (res.data.value) {
          const data = res.data.value
          if (user.crole == 'seller') {
            this.seller(data)
          } else if (user.crole == 'buyer') {
            this.buyer(data)
          } else if (user.crole == 'partner') {
            this.partner()
          }
        }
      })
    },
    async buyer(data) {
      let authUser = this.$store.state.auth.user;
      if (authUser.crole == 'buyer') {
        let isReadOnly = authUser.user_role === 'read_only_access';
        let isTradeOnly = authUser.user_role === 'trade_only_access'
        let isDepositWithdrawOnly = authUser.user_role === 'deposit_withdraw_only_access'

        if (!isReadOnly && !isDepositWithdrawOnly) {
          this.myItems.push({
            title: 'my_invoices',
            route: 'my_invoices',
            icon: 'FileTextIcon',
            id: 'MyInvoices',
          })
        }

        if (!isReadOnly && !isDepositWithdrawOnly) {
          this.myItems.push({
            title: 'market',
            route: 'market',
            icon: 'ShoppingCartIcon',
          })
        }

        if (!isReadOnly && !isDepositWithdrawOnly) {
          this.myItems.push({
            title: 'investment_profile',
            route: 'investment_profile',
            icon: 'SlidersIcon',
            tooltip: 'investment_tooltip_profile',
          })
        }

        // if (this.company?.name != null && !isReadOnly && !isTradeOnly && !isDepositWithdrawOnly) {
        //   this.myItems.push({
        //     title: 'documents',
        //     route: 'upload-docs',
        //     icon: 'FileIcon',
        //   })
        // }

        if (!isReadOnly && !isTradeOnly && !isDepositWithdrawOnly) {
          const active = this.referralIsActiveForRole('buyer')
          let tooltip_text = active ? '' : 'referral_tooltip';
          this.myItems.push({
            title: 'referral_program',
            route: active ? 'referralProgram' : null,
            icon: 'UserPlusIcon',
            id: 'sideBarProgram',
            tooltip: tooltip_text,
          })
        }

        this.myItems.push({
          title: 'tax_statement',
          route: 'tax_statement',
          icon: 'FileTextIcon',
          id: 'statement',
        })


        if (!isReadOnly && !isTradeOnly && !isDepositWithdrawOnly) {
          this.myItems.push({
            title: 'identification',
            route: 'identification',
            icon: 'UserCheckIcon',
          })
        }

        this.myItems.push({
          title: 'Team',
          route: 'team',
          icon: 'UsersIcon',
          id: 'companyTeam',
        })

      }

      this.load = true
    },

    seller(data) {
      let invoice = false
      let docs = false
      let isReadOnly = this.$store.state.auth.user.user_role === 'read_only_access'
      let isTradeOnly = this.$store.state.auth.user.user_role === 'trade_only_access'
      let isDepositWithdrawOnly = this.$store.state.auth.user.user_role === 'deposit_withdraw_only_access'

      if (
          (data[1].status == 2 || data[1].status == 1)
          && data[1].task_id == 2
      ) {
        invoice = true
      }
      if (
          (data[2].status == 2 || data[2].status == 1)
          && data[2].task_id == 3
      ) {
        docs = true
      }

      if (this.$store.state.auth.user.crole == 'seller') {
        this.$store.commit('app/CHECK_FOR_INVOICE', true)
        if (!isReadOnly && !isDepositWithdrawOnly) {
          this.myItems.push({
            title: 'invoices',
            route: 'invoices',
            icon: 'FileTextIcon',
            id: 'sideBarInvoices',
          })
        }

        this.$store.commit('app/CHECK_FOR_DOCS', true)

        if (!isReadOnly && !isTradeOnly  && !isDepositWithdrawOnly) {
          this.myItems.push({
            title: 'documents',
            route: 'documents',
            icon: 'FileIcon',
            id: 'sideBarDocument',
          })
        }

        if (!isReadOnly && !isTradeOnly && !isDepositWithdrawOnly) {
          const active = this.referralIsActiveForRole('seller')
          let tooltip_text = active ? '' : 'referral_tooltip';
          this.myItems.push({
            title: 'referral_program',
            route: active ? 'referralProgram' : null,
            icon: 'UserPlusIcon',
            id: 'sideBarProgram',
            tooltip: tooltip_text,
          })
        }

        if (!isTradeOnly && !isDepositWithdrawOnly) {
          this.myItems.push({
            title: 'billing',
            route: 'billing',
            icon: 'CreditCardIcon',
            id: 'sideBarProgram',
          })
        }

        this.myItems.push({
          title: 'Team',
          route: 'team',
          icon: 'UsersIcon',
          id: 'companyTeam',
        })
        this.myItems.push({
          title: 'annual_activity_summary',
          route: 'annual-activity-summary',
          icon: 'FileTextIcon',
          id: 'annual-activity-summary',
        })
      }

      this.$store.dispatch('app/fetchCompany').then((data) => {
        if (data?.value?.buyer == 1) {
          this.myItems.push({
            title: 'market',
            route: 'market',
            icon: 'ShoppingCartIcon',
          })
        }
      })
      this.load = true
      this.$forceUpdate()
    },

    async partner() {
      let authUser = this.$store.state.auth.user;
      if (authUser.active) {

        this.myItems.push({
          title: 'referral_program',
          route: 'referralProgram',
          icon: 'UserPlusIcon',
          id: 'sideBarProgram',
        })

        this.myItems.push({
          title: 'Team',
          route: 'team',
          icon: 'UsersIcon',
          id: 'companyTeam',
        })
      }
      this.load = true
    },
  },
  setup() {
    provide('openGroups', ref([]))
    return {
      resolveNavItemComponent,
    }
  },
}
</script>
